import { z } from 'zod';
import { recaptchaTokenSchema } from './shared.js';
/**
 * Job application proxied to Manatal. Mirrors JobController::apply().
 * The three fixed fields are always required; any extra Manatal dynamic-schema
 * fields are passed through untouched.
 */
export const jobApplySchema = z
    .object({
    full_name: z.string().min(1).max(255),
    email: z.string().email(),
    phone_number: z.string().min(1),
    hasResumeFile: z.boolean().default(false),
    recaptchaToken: recaptchaTokenSchema,
})
    .catchall(z.string())
    .refine((v) => v.hasResumeFile, { message: 'resumeRequired', path: ['hasResumeFile'] });
//# sourceMappingURL=jobApply.js.map